import { AxiosRequestConfig } from "axios";
import { useState } from "react";
import assetClient from "src/services/assetClient";

export const useAzureFileUpload = (
	setUUID?: (uuid: string | null | string[]) => void,
	setIndex?: (uuid: string | null, index?: number) => void
) => {
	const [progress, setProgress] = useState<number>(0);

	const [done, setDone] = useState<boolean>(false);

	const [error, setError] = useState<boolean>(false);

	const [uploading, setUploading] = useState<boolean>(false);

	const onUploadFailed = () => {
		setUploading(false);

		setError(true);
	};

	const onUploadSuccess = (result: any, index?: number) => {
		const { data } = result;

		if (data.length === 0) {
			// something didn't work
			return;
		}

		// this UUID needs to be set on the `image_portrait_uuid` field or whatever field
		// will be linked to the image/video
		setUUID?.(data);

		if (setIndex) {
			setIndex(data, index);
		}

		setDone(true);
		setError(false);
		setUploading(false);

		return data;
	};

	const upload = (
		file: File,
		uploadType: string,
		index?: number,
		imageProfile?: ImageProfile
	) => {
		const formData = new FormData();
		formData.append("File", file);

		setUploading(true);
		setError(false);
		setDone(false);
		setProgress(0);

		const axiosConfig = {
			headers: {
				"Content-Type": "multipart/form-data",
				Accept: "application/json"
			},
			onUploadProgress: (progressEvent: any) => {
				setProgress(progressEvent.loaded / progressEvent.total);
			},
			params: {
				profileName: imageProfile
			}
		} as AxiosRequestConfig;

		return assetClient
			.post(
				`/api/v1.0/Upload/${uploadType}${
					uploadType === "video" ? "/public" : ""
				}`,
				formData,
				axiosConfig
			)
			.then((result) => onUploadSuccess(result, index), onUploadFailed);
	};

	const clear = () => {
		setUUID?.(null);
		setProgress(0);
		setError(false);
		setDone(false);
	};

	return {
		progress,
		done,
		error,
		uploading,
		upload,
		clear
	};
};
